<div class="shareContainer">

  <div class="shareModalBox">
    <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
    </div>
    <span class="title-share">{{'enableNotifications' | translate}}</span>
    <div class="txt-description">
      {{'newNotifications' | translate }}
    </div>
    <br>
    <ion-button class="boostButton button-round" shape="round" fill="solid" color="primary" (click)="enableNotifications()">
      {{'enableNotifications' | translate}}
    </ion-button>
  </div>
</div>